/**
 * Resuelve URL de bandera: override absoluto o SVG local por ISO-2.
 * Assets: `assets/flags/4x3/{iso}.svg` (paquete flag-icons).
 */
export function resolveCountryFlagIconUrl(options: {
  iso?: string | null;
  flagUrl?: string | null;
  iconUrl?: string | null;
}): string | undefined {
  const custom = (options.flagUrl ?? options.iconUrl)?.trim();
  if (
    custom &&
    (custom.startsWith('http://') ||
      custom.startsWith('https://') ||
      custom.startsWith('/') ||
      custom.startsWith('assets/'))
  ) {
    return custom;
  }

  const iso = options.iso?.trim().toLowerCase();
  if (iso && /^[a-z]{2}$/.test(iso)) {
    return `assets/flags/4x3/${iso}.svg`;
  }
  return undefined;
}

/** Prefijo de lada al estilo UI admin: "+ 54". */
export function formatLadaSelectValue(rawLada: string): string {
  const digits = rawLada.trim().replace(/^\++/, '').replace(/\s+/g, '');
  return digits ? `+ ${digits}` : '';
}
